@if (isLaptop() && !iconOnly()) {
    <button
        qpxButton
        [matButton]="appearance()"
        size="sm"
        class="icon-only rounded-e-none! no-disabled-color"
        [disabled]="disabled()"
        [attr.aria-label]="`Sort ${entityLabel()} direction: ${directionLabel()}`"
        [qpxTooltip]="`Sort ${entityLabel()} ${directionLabel()}`"
        (click)="toggleDirection()"
    >
        <ng-icon qpx size="sm" [name]="directionIcon()" matButtonIcon />
    </button>

    <button
        qpxButton
        [matButton]="appearance()"
        size="sm"
        class="label-truncate rounded-s-none! no-disabled-color -ml-px"
        [matMenuTriggerFor]="sortMenu"
        [disabled]="disabled()"
        [attr.aria-label]="`Sort ${entityLabel()} by ${sortByLabel()}`"
    >
        <span>Sort by {{ sortByLabel() }}</span>
        <ng-icon
            qpx
            size="sm"
            name="lucideChevronDown"
            matButtonIcon
            iconPositionEnd
        />
    </button>
} @else {
    <button
        qpxButton
        [matButton]="appearance()"
        size="sm"
        class="filter-row-control"
        [class.icon-only]="iconOnly()"
        [qpxTooltip]="
            disabled() && disabledReason() ? disabledReason() : 'Sort'
        "
        [matTooltipDisabled]="!iconOnly() && !(disabled() && disabledReason())"
        [class.cursor-not-allowed!]="disabled()"
        [class.opacity-55]="disabled()"
        [disabled]="disabled()"
        [disabledInteractive]="disabled() && iconOnly()"
        [attr.aria-expanded]="isCompactPopoverOpen()"
        [attr.aria-label]="`Sort ${entityLabel()} direction: ${directionLabel()}`"
        aria-haspopup="dialog"
        (click)="toggleCompactPopover($event)"
    >
        <ng-icon qpx size="sm" [name]="directionIcon()" matButtonIcon />
        @if (!iconOnly()) {
            <span class="filter-row-control-label">Sort</span>
        }
    </button>
}

<mat-menu #sortMenu="matMenu" [attr.aria-label]="menuAriaLabel()">
    @for (parameter of parameters(); track parameter.id) {
        <button
            mat-menu-item
            type="button"
            role="menuitemradio"
            [attr.aria-checked]="selectedParameter().id === parameter.id"
            [class.text-primary-muted]="selectedParameter().id === parameter.id"
            (click)="selectParameter(parameter)"
        >
            <span class="grow">{{ parameter.label }}</span>
            @if (selectedParameter().id === parameter.id) {
                <ng-icon
                    qpx
                    class="order-last ml-3! mr-0! text-primary-muted"
                    name="lucideCheck"
                    matMenuItemIcon
                />
            }
        </button>
    }
</mat-menu>
